import * as React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

export const Template = `<tb:request-password-reset />`;

export interface RequestPasswordResetProviderProps extends ReactDirectiveProps {}

export const RequestPasswordResetProvider = (props: RequestPasswordResetProviderProps): JSX.Element => {
  return(
    <DefaultServerTitleWrapper>
      <div>
        <AngularDirective
          angularContext={props.angularContext}
          template={Template}
        />
      </div>
    </DefaultServerTitleWrapper>
  );
};
